import { Button } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Toolbar from '@material-ui/core/Toolbar';
import React from 'react';
import PatientEndScreen from '../../assets/images/PatientEndScreen.svg';
import { useAppState } from '../../state';
import { SUPPORT, USER_HOME_URL } from '../../utils/constants';
import Logo from '../Logo/Logo';
import './PatientEndCallDialog.scss';

export default function PatientEndCallDialog() {
    const { isPatientEndCallDialogVisible } = useAppState();

    const onClickBackToYourAccount = (e: any) => {
        e.preventDefault();
        window.location.href = USER_HOME_URL;
    };

    return (
        <Dialog
            open={isPatientEndCallDialogVisible}
            fullWidth={true}
            maxWidth="xs"
            className="patient-end-screen-dialog"
        >
            <AppBar position="static" className="inner-block">
                <Toolbar>
                    <Logo />
                </Toolbar>
            </AppBar>
            <DialogContent>
                <img src={PatientEndScreen} />
                <h4 className="header1">
                    <div>Thanks for stopping by!</div>
                </h4>
                <div className="content">
                    <div>
                        You will receive an email soon with any follow
                        up&nbsp;instructions.
                    </div>

                    <div>
                        If you have any questions, reach out to our friendly
                        <a href={SUPPORT}> customer support team</a>.
                    </div>
                </div>
                <Button className="btn--lrg" onClick={onClickBackToYourAccount}>
                    Back to account
                </Button>
            </DialogContent>
        </Dialog>
    );
}
